import React from 'react';
import moment from 'moment';
import queryString from 'query-string';

import { history } from '../../../../_helpers/history';
import { useDispatch } from 'react-redux';
import { formService } from '../../../../_services/form.service';
import { alertActions } from '../../../../_actions/alert.actions';

export default function ExportForms() {
  const dispatch = useDispatch();

  const handleExport = (type) => {
    dispatch(alertActions.clear());

    const queryParams = queryString.parse(history.location.search);
    const showDateRange = ("completeByStartDate" in queryParams) ? true : false;

    const searchParams = {
      type: type,
      firstName: queryParams.firstName || '',
      lastName: queryParams.lastName || '',
      dateOfBirth: queryParams.dateOfBirth || '',
      completeByDate: !showDateRange ? queryParams.completeByDate || '' : '',
      completeByStartDate: showDateRange ? queryParams.completeByStartDate || '' : '',
      completeByEndDate: showDateRange ? queryParams.completeByEndDate || '' : '',
      groupId: queryParams.location ? parseInt(queryParams.location) : '',
      providerId: queryParams.professional ? parseInt(queryParams.professional) : '',
      status: queryParams.status || '',
      questionnaireId: queryParams.form ? parseInt(queryParams.form) : '',
    };

    formService.exportToken(searchParams)
      .then(data => {
        window.open(data.url);
      })
      .catch((error) => {
        dispatch(alertActions.error('We could not export the results at this time. Please try again.'));
      });
  }

  const showSelectExportType = () => {
    dispatch(alertActions.clear());

    const queryParams = queryString.parse(history.location.search);
    const showDateRange = ("completeByStartDate" in queryParams) ? true : false;

    if (showDateRange && (!queryParams.completeByStartDate || !queryParams.completeByEndDate)) {
      dispatch(alertActions.warning('Narrow your results by selecting a "Complete By Date Range".'));
    } else if (showDateRange && (moment(queryParams.completeByEndDate).diff(moment(queryParams.completeByStartDate), 'days') > 90)) {
      dispatch(alertActions.warning('Narrow your results by selecting a "Complete By Date Range" of no more than 90 days.'));
    } else if (showDateRange && (!queryParams.completeByStartDate || !queryParams.completeByEndDate) && !queryParams.form) {
      dispatch(alertActions.warning('Before exporting, select a "Complete By Date" range and a "Form".'));
    } else if (!showDateRange && !queryParams.completeByDate && !queryParams.form) {
      dispatch(alertActions.warning('Narrow your results by entering a "Complete By Date" and "Form".'));
    } else if (!queryParams.form) {
      dispatch(alertActions.warning('Narrow your results by selecting "Form".'));
    } else if (!showDateRange && !queryParams.completeByDate) {
      dispatch(alertActions.warning('Narrow your results by entering "Complete By Date".'));
    } else if (!showDateRange && (moment(queryParams.completeByDate, 'MM/DD/YYYY').isValid() === false)) {
      dispatch(alertActions.warning('Complete By Date date is invalid.'));
    } else {
      handleExport('full');
    }
  }

  return <button type="button" onClick={showSelectExportType} className="btn btn-outline-primary px-5">Export Form Data</button>
}